import type { File2DDoc } from '../../../../../types/api.types';
import { Row } from '@/components/ui/layout/Row';
import { Column } from '@/components/ui/layout/Column';
import { Text } from '@/components/ui/base/Text';

interface TwoDDocPanelProps {
  ddoc?: File2DDoc;
}

export const TwoDDocPanel = ({ ddoc }: TwoDDocPanelProps) => {
  if (!ddoc) {
    return (
      <Column className="my-3">
        <Text size="md" weight="medium">
          Aucune donnée disponible pour ce 2D-DOC
        </Text>
      </Column>
    );
  }

  return (
    <Column gap="xs">
      <Row align="end">
        <Text size="sm">Type :</Text>
        <Text weight="medium">{ddoc.type}</Text>
      </Row>

      <Row align="end">
        <Text size="sm">Signature : </Text>
        <Text weight="medium">{ddoc.is_signed ? 'Signé' : 'Non signé'}</Text>
      </Row>

      <Column align="start" style={{ marginTop: '4px' }}>
        <Text size="sm">Champs :</Text>
        <Column>
          {Object.entries(ddoc.fields || {}).map(([key, value]) => (
            <Row
              key={key}
              className="relative rounded-md bg-[#f0f2f7] p-2 dark:bg-opacity-5"
              justify="between"
            >
              <Text size="sm" className="shrink-0">
                {key} :
              </Text>
              <Text
                weight="medium"
                truncate
                data-tooltip-content={value}
                data-tooltip-place="top"
                data-tooltip-delay-show={100}
                data-tooltip-offset={5}
                data-tooltip-id={`tooltip`}
              >
                {value}
              </Text>
            </Row>
          ))}
        </Column>
      </Column>
    </Column>
  );
};
